import React from 'react';
import { useAuth } from '../../context/AuthContext';

const AdminHeader = ({ currentView = 'dashboard', onNavigate }) => {
  const { user, logout } = useAuth();

  const handleLogout = () => {
    logout();
  };

  return (
    <header className="admin-header">
      <div className="header-content">
        <div className="logo-section">
          <h1 className="logo">SecHire</h1>
          <span className="admin-badge">ADMIN</span>
        </div>
        <nav className="admin-nav">
          <button
            className={`nav-link ${currentView === 'dashboard' ? 'active' : ''}`}
            onClick={() => onNavigate && onNavigate('dashboard')}
          >
            Dashboard
          </button>
          <button
            className={`nav-link ${currentView === 'people' ? 'active' : ''}`}
            onClick={() => onNavigate && onNavigate('people')}
          >
            People
          </button>
          <button
            className={`nav-link ${currentView === 'assessments' ? 'active' : ''}`}
            onClick={() => onNavigate && onNavigate('assessments')}
          >
            Assessments
          </button>
          <button
            className={`nav-link ${currentView === 'jobs' ? 'active' : ''}`}
            onClick={() => onNavigate && onNavigate('jobs')}
          >
            Jobs
          </button>
          <button
            className={`nav-link ${currentView === 'training' ? 'active' : ''}`}
            onClick={() => onNavigate && onNavigate('training')}
          >
            Training
          </button>
          <button
            className={`nav-link ${currentView === 'analytics' ? 'active' : ''}`}
            onClick={() => onNavigate && onNavigate('analytics')}
          >
            Analytics
          </button>
          <button
            className={`nav-link ${currentView === 'permissions' ? 'active' : ''}`}
            onClick={() => onNavigate && onNavigate('permissions')}
          >
            Permissions
          </button>
          <button
            className={`nav-link ${currentView === 'settings' ? 'active' : ''}`}
            onClick={() => onNavigate && onNavigate('settings')}
          >
            Settings
          </button>
          <button
            className={`nav-link ${currentView === 'integrations' ? 'active' : ''}`}
            onClick={() => onNavigate && onNavigate('integrations')}
          >
            Integrations
          </button>
        </nav>
        <div className="user-menu">
          <span className="user-email">{user?.email}</span>
          <button className="cyber-btn danger" onClick={handleLogout}>
            Logout
          </button>
        </div>
      </div>
    </header>
  );
};

export default AdminHeader;
